module.exports = __webpack_public_path__ + "front/img/poster5.c748d0ef.jpg";